// src/components/Hero.js
import React from "react";
import heroImg from "../assets/hero-placeholder.svg";

const Hero = () => {
  const scrollToForm = () => {
    const el = document.getElementById("lead-form");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero-inner fade-slide-up">

        <div className="hero-text">
          <p className="eyebrow">
            Digital Marketing • Apps • Websites • Branding
          </p>

          <h1 id="hero-heading">
            Turn clicks into clients with a{" "}
            <span className="text-gradient">
              High-Converting Website Development for Businesses
            </span>.
          </h1>

          <p className="hero-sub">
            HFA Digital Creations helps startups and growing businesses get more
            qualified leads, high-converting websites, and ROI-driven marketing
            campaigns without guesswork.
          </p>

          <div className="hero-actions">

            {/* Main CTA */}
            <button
              className="btn-primary glow-pulse"
              onClick={scrollToForm}
            >
              Get a Custom Website Quote
            </button>

            {/* Visit Official Website */}
            <a
              href="https://hfadigitalcreations.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary visit-site-btn"
            >
              Visit Our Official Site
              <span className="arrow">↗</span>
            </a>


          </div>
          <div className="hero-trust">
            {/* <span className="trust-badge">Trusted by 25+ Businesses</span> */}
            <span className="trust-copy">Across India and growing.</span>
          </div>
        </div>

        <div className="hero-visual">
          <img
            src={heroImg}
            alt="Digital marketing team analyzing growth dashboards and website performance"
            loading="lazy"
            className="hero-image glow-border"
          />

          <div className="hero-stats-card glass-card">
            <p className="hero-stats-label">Average 3x increase</p>
            <p className="hero-stats-value">in monthly leads</p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;